import { Stack, StackProps } from '@chakra-ui/react';

export default function MainFlowLayout({ children, ...rest }: StackProps) {
  return (
    <Stack gap="10px" px="21px" pb="16px" h="100vh" w="full" overflow="hidden" {...rest}>
      {children}
    </Stack>
  );
}
